
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/forgotPassword",
      function () {
        return require("private-next-pages/user/forgotPassword.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/forgotPassword"])
      });
    }
  